import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject, Subscription, fromEvent } from "rxjs";

import { TemasApp } from "../constants/lista.temas";
import { UsuarioPreferenciasService } from "./data-services/usuario.preferencias.service";
import { map } from "rxjs/operators";
import { Platform } from "@angular/cdk/platform";
import { BreakpointObserver } from "@angular/cdk/layout";
import { Tema } from "../models/tema";

@Injectable()
export class UiService {
  private idTema = 2;

  private tema: Tema = TemasApp[this.idTema];

  private tema$ = new BehaviorSubject<Tema>(this.tema);

  private isBreakPoint$: Subscription = Subscription.EMPTY;
  private lockOrientation$: Subscription = Subscription.EMPTY;

  private mobile: boolean = this.platform.ANDROID || this.platform.IOS;
  private mobile$ = new BehaviorSubject<boolean>(this.mobile);

  private breakpointSm: boolean = window.innerWidth <= 430;
  private breakpointSm$ = new BehaviorSubject<boolean>(this.breakpointSm);

  private breakpointMd: boolean = window.innerWidth <= 744;
  private breakpointMd$ = new BehaviorSubject<boolean>(this.breakpointMd);

  private breakpointLg: boolean = window.innerWidth <= 1024;
  private breakpointLg$ = new BehaviorSubject<boolean>(this.breakpointLg);

  private larguraTela: number = window.innerWidth;
  private larguraTela$ = new BehaviorSubject<number>(this.larguraTela);

  private alturaTela: number = window.innerHeight;
  private alturaTela$ = new BehaviorSubject<number>(this.larguraTela);

  private isDesktop = !this.mobile;
  private isIOS: boolean = this.platform.IOS;
  private isAndroid: boolean = this.platform.ANDROID;

  constructor(
    private usuarioPreferenciasService: UsuarioPreferenciasService,
    private platform: Platform,
    private breakpointObserver: BreakpointObserver
  ) {
    this.usuarioPreferenciasService.getConfiguracoes().subscribe((config) => {
      if (config && this.idTema !== config.idTema) {
        this.idTema = config.idTema;
        this.updateTema();
      }
    });

    this.breakpointObserver.observe("(max-width: 430px)").subscribe((value) => {
      this.breakpointSm = value.matches;

      this.updateBreakpointSm();
    });
    this.breakpointObserver.observe("(max-width: 744px)").subscribe((value) => {
      this.breakpointMd = value.matches;

      this.updateBreakpointMd();
    });
    this.breakpointObserver
      .observe("(max-width: 1024px)")
      .subscribe((value) => {
        this.breakpointLg = value.matches;

        this.updateBreakpointLg();
      });

    this.isBreakPoint$ = fromEvent(window, "resize")
      .pipe(map(() => window))
      .subscribe((window) => {
        this.larguraTela = window.innerWidth;
        this.alturaTela = window.innerHeight;
        this.updateLarguraTela();
        this.updateAlturaTela();
        this.updateMobile();
      });

    this.lockOrientation$ = fromEvent(window.screen.orientation, "change")
      .pipe(map(() => window.screen))
      .subscribe((screen) => {
        if (
          (screen.orientation.type.startsWith("landscape-primary") ||
            screen.orientation.type.startsWith("landscape-secondary")) &&
          this.isMobile &&
          this.breakpointSm
        ) {
          window.screen.orientation.lock("portrait");
        }
      });
  }

  public get isMobile(): boolean {
    return this.mobile;
  }

  public get isIos(): boolean {
    return this.isIOS;
  }

  public get isBreakpointMd(): boolean {
    return this.breakpointMd;
  }

  public get isBreakpointLg(): boolean {
    return this.breakpointLg;
  }

  public getMobile(): Observable<boolean> {
    return this.mobile$.asObservable();
  }

  public getBreakpointLg(): Observable<boolean> {
    return this.breakpointLg$.asObservable();
  }

  public getBreakpointSm(): Observable<boolean> {
    return this.breakpointSm$.asObservable();
  }

  public getBreakpointMd(): Observable<boolean> {
    return this.breakpointMd$.asObservable();
  }

  public alterarTema(tema: Tema): void {
    this.tema$.next(tema);
  }

  public getLarguraTela(): Observable<number> {
    return this.larguraTela$.asObservable();
  }

  public getAlturaTela(): Observable<number> {
    return this.alturaTela$.asObservable();
  }

  public getTema(): Observable<Tema> {
    return this.tema$.asObservable();
  }

  private updateTema(): void {
    this.tema$.next(TemasApp[this.idTema]);
  }

  private updateAlturaTela(): void {
    this.alturaTela$.next(this.alturaTela);
  }

  private updateMobile(): void {
    this.mobile$.next(this.mobile);
  }

  private updateBreakpointSm(): void {
    this.breakpointSm$.next(this.breakpointSm);
  }
  private updateBreakpointMd(): void {
    this.breakpointMd$.next(this.breakpointMd);
  }
  private updateBreakpointLg(): void {
    this.breakpointLg$.next(this.breakpointLg);
  }
  private updateLarguraTela(): void {
    this.larguraTela$.next(this.larguraTela);
  }
}
